import { render, staticRenderFns } from "./EnableVendorModal.vue?vue&type=template&id=f75072e2"
import script from "./EnableVendorModal.vue?vue&type=script&lang=ts"
export * from "./EnableVendorModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports